import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/sections";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/contacts").then(r => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-contacts">
      <div className="overline">Inbox</div>
      <h1 className="display text-5xl mt-3">Messages.</h1>

      <div className="mt-10 space-y-4">
        {loading && <div className="text-muted2">Loading…</div>}
        {!loading && items.length === 0 && <div className="text-muted2">No messages.</div>}
        {items.map(c => (
          <div key={c.id} className="border border-soft bg-white p-6" data-testid={`contact-row-${c.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="font-serif text-xl">{c.name}</div>
                <div className="text-xs text-muted2">{c.email} · {c.phone}</div>
              </div>
              <div className="text-xs text-muted2">{formatDate(c.created_at)}</div>
            </div>
            {c.subject && <div className="overline mt-4">{c.subject}</div>}
            <p className="text-sm mt-2 whitespace-pre-wrap leading-relaxed">{c.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
